import { mergeClassnames } from '@heathmont/moon-core-tw';

type Props = { highlight?: boolean };

const Container: FC<Props> = ({ children, highlight }) => (
  <div
    className={mergeClassnames(
      'grid grid-flow-col items-center gap-1 p-2',
      highlight && 'm-0 rounded-moon-s-sm bg-goku',
    )}
  >
    {children}
  </div>
);

export default Container;
